import React, { useState } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";

function PDPFormDialog({ formTitle, submitLabel = "Save", canComplete = false, onSave, onClose, data = {}, ...props }) {
    const [title, setTitle] = useState(data.title || "");
    const [description, setDescription] = useState(data.description || "");
    const [status, setStatus] = useState(data.status || "");

    const onSubmit = () => {
        onSave({ title, description, status });
        onClose();
    };

    return (
        <Dialog
            open={!!props.open}
            onClose={onClose}
            fullWidth={true}
            maxWidth="md"
            scroll="paper"
        >
            <DialogTitle>{formTitle}</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    {canComplete ? (
                        <>
                            <FormGroup>
                                <FormControlLabel
                                    label="Completed"
                                    control={
                                        <Checkbox
                                            value="completed"
                                            checked={status === "completed"}
                                            onChange={(e) => setStatus(e.target.checked ? "completed" : "open")}
                                        />
                                    }
                                />
                                <FormHelperText>
                                    Mark this PDP as completed
                                </FormHelperText>
                            </FormGroup>
                        </>
                    ) : (
                        <>
                            <FormControl
                                component="div"
                                margin={"normal"}
                                fullWidth={true}
                                required={true}
                                error={!title}
                            >
                                <InputLabel id="label-title" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                                    Title
                                </InputLabel>
                                <OutlinedInput
                                    id="text-title"
                                    placeholder="Title"
                                    autoFocus={true}
                                    value={title}
                                    onChange={({ target }) => setTitle(target.value)}
                                    inputProps={{ maxLength: 140 }}
                                />
                                <FormHelperText>
                                    Up to 140 characters
                                </FormHelperText>
                            </FormControl>

                            <FormControl
                                component="div"
                                margin={"normal"}
                                fullWidth={true}
                            >
                                <InputLabel id="label-description" sx={{backgroundColor: "#FFF", padding: "0 4px"}}>
                                    Description
                                </InputLabel>
                                <OutlinedInput
                                    id="text-description"
                                    placeholder="Description"
                                    multiline
                                    rows={4}
                                    value={description}
                                    onChange={({ target }) => setDescription(target.value)}
                                />
                                <FormHelperText>Add text here</FormHelperText>
                            </FormControl>
                        </>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    onClick={onSubmit}
                    disabled={canComplete ? status !== "completed" : !title}
                >
                    {submitLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PDPFormDialog;
